/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {useIsMobile} from "../../../table/Table";
import {DeliveryNoteRowSkeletonMobile} from "./DeliveryNoteRowSkeletonMobile";
import {DeliveryNoteRowSkeleton} from "./DeliveryNoteRowSkeleton";

export const DeliveryNoteSkeleton = () => {
    const isMobile = useIsMobile();

    return isMobile ?
        <>{[...Array(5)].map((item, i) => <DeliveryNoteRowSkeletonMobile key={i}/>)}</>
        :
        <>{[...Array(5)].map((item, i) => <DeliveryNoteRowSkeleton key={i}/>)}</>
}

